if (!customElements.get('raffle-card')) {
  customElements.define(
    'raffle-card',
    class RaffleCard extends HTMLElement {
      connectedCallback() {
        this.ticketsEl = this.querySelector('[data-raffle-tickets]');
        this.countdownEl = this.querySelector('[data-raffle-countdown]');
        this.units = {
          days: this.querySelector('[data-raffle-days]'),
          hours: this.querySelector('[data-raffle-hours]'),
          minutes: this.querySelector('[data-raffle-minutes]'),
          seconds: this.querySelector('[data-raffle-seconds]'),
        };

        this.timezone = this.dataset.timezone || 'Asia/Jerusalem';
        this.start = this.toTimestamp(this.dataset.start);
        this.end = this.toTimestamp(this.dataset.end);
        this.hideAfterEnd = this.dataset.hideAfterEnd !== 'false';
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const { sectionId, variant } = event.data || {};
            if (sectionId !== this.dataset.sectionId || !variant) return;
            this.setTickets(variant.price, Number(this.dataset.salePercent) || 0);
          });
        }

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.variantUnsubscriber) this.variantUnsubscriber();
      }

      /** Tickets = FINAL price (after the storewide sale percent) in whole shekels, no decimals. Price comes in cents. */
      setTickets(priceInCents, salePercent = 0) {
        if (!this.ticketsEl || typeof priceInCents !== 'number') return;
        const finalCents = salePercent > 0 ? Math.round((priceInCents * (100 - salePercent)) / 100) : priceInCents;
        this.ticketsEl.textContent = Math.floor(finalCents / 100);
      }

      /** Parses "YYYY-MM-DD HH:MM" as wall-clock time in the configured timezone. */
      toTimestamp(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?(?::(\d{2}))?$/.exec((value || '').trim());
        if (!match) return null;

        const [, year, month, day, hour = 0, minute = 0, second = 0] = match.map((part) => (part === undefined ? part : Number(part)));
        const wallClock = Date.UTC(year, month - 1, day, hour, minute, second);

        try {
          let offset = this.timezoneOffset(wallClock);
          offset = this.timezoneOffset(wallClock - offset);
          return wallClock - offset;
        } catch (error) {
          return new Date(year, month - 1, day, hour, minute, second).getTime();
        }
      }

      timezoneOffset(timestamp) {
        const parts = {};
        new Intl.DateTimeFormat('en-US', {
          timeZone: this.timezone,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
          .formatToParts(new Date(timestamp))
          .forEach(({ type, value }) => {
            parts[type] = Number(value);
          });

        const asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
        return asUtc - Math.floor(timestamp / 1000) * 1000;
      }

      tick() {
        const now = Date.now();
        const notStarted = this.start !== null && now < this.start;
        const ended = this.end !== null && now >= this.end;

        const shouldHide = !this.designMode && (notStarted || (ended && this.hideAfterEnd));
        this.hidden = shouldHide;
        if (shouldHide) return;

        if (this.end === null || !this.countdownEl) return;

        const remaining = Math.max(0, this.end - now);
        const totalSeconds = Math.floor(remaining / 1000);
        const pad = (number) => String(number).padStart(2, '0');

        this.units.days.textContent = pad(Math.floor(totalSeconds / 86400));
        this.units.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        this.units.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        this.units.seconds.textContent = pad(totalSeconds % 60);
      }
    }
  );
}
